{
  "about": "Mehr zu {{name}}",
  "cancel": "Abbrechen",
  "changes": {"added": "Hinzugefügt:", "changed": "Geändert:", "removed": "Entfernt:"},
  "close": "Schließen",
  "copyReference": {
    "copied": "Kopiert",
    "failed": "Kopieren fehlgeschlagen",
    "label": "Referenz kopieren"
  },
  "loading": "Wird geladen …",
  "settings": {
    "reason": "Begründung",
    "reasonHint": "Warum sich das ändert. Alle, die den Verlauf lesen, sehen sie.",
    "save": "Speichern"
  },
  "source": {
    "copy": "Kopieren",
    "layout": "Darstellung",
    "loadingEditor": "Editor wird geladen …",
    "nextChange": "Nächste Änderung",
    "noChanges": "Keine Änderungen.",
    "openComparison": "Vergleich öffnen",
    "openFull": "Vollansicht öffnen",
    "previousChange": "Vorige Änderung",
    "showUnchanged_one": "{{count}} unveränderte Zeile zeigen",
    "showUnchanged_other": "{{count}} unveränderte Zeilen zeigen",
    "sideBySide": "Nebeneinander",
    "unified": "Untereinander"
  },
  "typeToConfirm": "Zur Bestätigung „{{text}}“ eingeben"
}
